import hasValidationErrors from '../../components/connectedForm/utils/hasValidationErrors';
import { createBackgroundJob } from '../../utils/BackgroundJobs';
import { onDocumentComplete, onDocumentPrintFailed } from '../../utils/DocumentUtils';
import { DocumentNode } from 'graphql';
import { OverdueAccount } from '../../graphql/entities';
import { IJobInfo, IJobProgress } from '../../graphql/schema/p4types';
import { getMutationProps } from '../sales/DocumentAction';

const onComplete = (state: any, props: any, job: IJobInfo | IJobProgress): void => {
  const { overrideOutput, outputType, showSummary } = state;
  const { dispatch, onClose, onComplete, onProcessSummary, onProcessPreview } = props;

  onDocumentComplete({
    overrideOutput,
    outputType,
    documentName: 'Overdue Account',
    documentNamePlural: 'Overdue Accounts',
    dispatch,
    onClose: () => onClose(false, state, props, job),
    onComplete,
    showSummary,
    onProcessSummary: () => onProcessSummary(false, state, props, job),
    onProcessPreview,
    job,
  });
};

export const generate = (state: any, props: any, variables: object, returnUrl: string): void => {
  if (hasValidationErrors(props)) return;
  createBackgroundJob(
    OverdueAccount.generate as DocumentNode,
    getMutationProps(state, props, variables, 'overdueAccount'),
    props,
    returnUrl,
    'Print Overdue Account',
    (job: IJobInfo | IJobProgress) => onComplete(state, props, job)
  );
};

export const generateRange = (
  state: any,
  props: any,
  _variables: object,
  returnUrl: string,
  { rangeMutationProps }: { rangeMutationProps: object }
) => {
  if (hasValidationErrors(props)) return;
  createBackgroundJob(
    OverdueAccount.generateRange,
    rangeMutationProps,
    props,
    returnUrl,
    'Print Overdue Account(s)',
    (job: IJobInfo | IJobProgress) => onComplete(state, props, job),
    (job: IJobInfo | IJobProgress) => onDocumentPrintFailed(state, props, job)
  );
};
